import { Link, NavLink, Outlet } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { USER_ROLES } from '../../services/userService';

const PRIMARY_LINKS = [
  { href: '/about', label: 'About' },
  { href: '/articles', label: 'Articles' },
  { href: '/gallery', label: 'Gallery' },
  { href: '/course-content', label: 'Course Content' },
];

const DASHBOARD_LINKS = [
  { to: '/dashboard', label: 'Overview', end: true },
  { to: '/dashboard/articles', label: 'Articles' },
  { to: '/dashboard/staff-profiles', label: 'Staff Profiles' },
  { to: '/dashboard/gallery', label: 'Gallery' },
  { to: '/dashboard/course-content', label: 'Course Content' },
  { to: '/dashboard/uploads', label: 'Uploads' },
];

export default function DashboardLayout() {
  const { profile, signOut } = useAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isAdmin = profile?.role === USER_ROLES.ADMIN;
  const dashboardLinks = isAdmin
    ? [...DASHBOARD_LINKS, { to: '/dashboard/admin-users', label: 'Admin Users' }]
    : DASHBOARD_LINKS;

  async function handleSignOut() {
    try {
      setIsSigningOut(true);
      await signOut();
    } finally {
      setIsSigningOut(false);
    }
  }

  return (
    <div>
      <div className="navbar__wrap">
        <nav className="navbar navbar-default navbar-static-top" id="DWTop-Nav">
          <Link className="navbar-left navbar__item--logo" to="/">
            <img
              className="navbar__item--logo-image"
              src="/static/site_pictures/disinfo_badge_scaled_cropped.png"
              alt="Disinformation Warriors logo"
            />
          </Link>

          <button
            className="navbar-toggle"
            data-toggle="collapse"
            data-target=".navbar__collapsable--menu"
            style={{ marginTop: '3.5rem' }}
            type="button"
            onClick={() => setMenuOpen((current) => !current)}
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>

          <div
            className={`collapse navbar-collapse navbar__collapsable--menu${
              menuOpen ? ' in' : ''
            }`}
          >
            <ul
              className="nav navbar-nav navbar__list"
              id="nav-link-list"
              style={{ float: 'right' }}
            >
              {PRIMARY_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    className="navbar__item--link"
                    to={link.href}
                    onClick={() => setMenuOpen(false)}
                  >
                    |{link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  className="navbar__item--link"
                  to="/dashboard"
                  onClick={() => setMenuOpen(false)}
                >
                  |Dashboard
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  className="navbar-link-button navbar__item--link"
                  onClick={handleSignOut}
                  disabled={isSigningOut}
                >
                  |{isSigningOut ? 'Signing out...' : 'Sign out'}
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <div className="dashboard-shell">
        <aside className="dashboard-sidebar">
          <h2>Dashboard</h2>
          <p className="dashboard-role">Role: {profile?.role || 'viewer'}</p>
          <div className="dashboard-sidebar-actions">
            <Link to="/">Public site</Link>
          </div>
          <nav className="dashboard-nav">
            {dashboardLinks.map((link) => (
              <NavLink key={link.to} end={link.end} to={link.to}>
                {link.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section className="dashboard-content">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
